import * as React from 'react';
import {Link} from 'react-router-dom';
// @ts-expect-error
import type {LocationShape} from 'react-router-dom';

import styles from './page-title-breadcrumbs.module.css';

export type Breadcrumb = {
    to: string | LocationShape;
    text: string;
};

type Props = {
    title: string;
    breadcrumbs: Breadcrumb[];
};

export function PageTitleBreadcrumbs(props: Props): React.ReactElement {
    return (
        <div className={styles.breadcrumbs}>
            {props.breadcrumbs.map((breadcrumb: Breadcrumb, index: number): React.ReactElement => {
                return (
                    <span key={index} className={styles.breadcrumb}>
                        {/* @ts-expect-error */}
                        <Link to={breadcrumb.to}>{breadcrumb.text}</Link>
                        <span className={styles.divider}>&gt;</span>
                    </span>
                );
            })}
            <span className={styles.breadcrumb}>{props.title}</span>
        </div>
    );
}
